import queryString from 'query-string';
import { CALL_API } from 'middleware/api';
import { Categories } from 'utils/types/navigation';
import * as constants from '../constants';
import { prepareParams } from '../utils/prepareParams';
import * as localTypes from './types';
import * as invest from '../types';
export * from './topup';
export * from './autoinvest';
export const setReferrerId = (referrerId) => ({
    type: 'SET_REFERRER_ID',
    referrerId,
});
export const setAccountStatus = (status, broker, accountType) => ({
    broker,
    status,
    accountType,
    type: localTypes.SET_ACCOUNT_STATUS,
});
export const clearFirstAccountActivatedFlag = () => ({
    type: localTypes.CLEAR_FIRST_ACCOUNT_ACTIVATED_FLAG,
});
export const requestPhoneVerificationCode = (phoneNumber, countryCode, mode) => {
    const body = {
        phone_number: phoneNumber,
        country_code: countryCode,
        via: mode,
    };
    return {
        [CALL_API]: {
            endpoint: '/oauth/link-provider/phone/request_code',
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                localTypes.LINK_PHONE_GET_CODE_REQUEST,
                localTypes.LINK_PHONE_GET_CODE_SUCCESS,
                localTypes.LINK_PHONE_GET_CODE_FAILURE,
            ],
        },
    };
};
export const getTrustedContacts = () => ({
    [CALL_API]: {
        endpoint: '/trusted-contacts',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            localTypes.GET_TRUSTED_CONTACTS_REQUEST,
            localTypes.GET_TRUSTED_CONTACTS_SUCCESS,
            localTypes.GET_TRUSTED_CONTACTS_FAILURE,
        ],
    },
});
export const addTrustedContact = (data) => {
    const body = { ...data, relation: 'OTHER' };
    return {
        [CALL_API]: {
            endpoint: '/trusted-contacts',
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                localTypes.ADD_TRUSTED_CONTACT_REQUEST,
                localTypes.ADD_TRUSTED_CONTACT_SUCCESS,
                localTypes.ADD_TRUSTED_CONTACT_FAILURE,
            ],
            muteAlert: false,
        },
    };
};
export const editTrustedContact = (id, data) => {
    const body = { ...data, relation: 'OTHER' };
    return {
        [CALL_API]: {
            endpoint: `/trusted-contacts/${id}`,
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            types: [
                localTypes.EDIT_TRUSTED_CONTACT_REQUEST,
                localTypes.EDIT_TRUSTED_CONTACT_SUCCESS,
                localTypes.EDIT_TRUSTED_CONTACT_FAILURE,
            ],
            muteAlert: false,
        },
    };
};
export const createTradingAccount = (props) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/accounts',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            broker: props.broker,
            trustedContactId: undefined,
            accountType: props.accountType,
            immediateFamilyExposed: props.isPoliticallyExposed,
            isAffiliatedExchangeOrFinra: props.isAffiliatedExchangeOrFinra,
            isControlPerson: props.isControlPerson,
            isPoliticallyExposed: props.isPoliticallyExposed,
            signedElectronicSignature: true,
            signedNotUSResident: true,
            ...(props.accountType === 'ISA' ? { signedIsaDeclaration: constants.SECCL_ISA_DECLARATION } : {}),
            ...(props.accountType === 'JISA' ? { signedJisaDeclaration: constants.SECCL_JISA_DECLARATION } : {}),
            signedAccountAgreement: constants.SECCL_CUSTODIAN_TERMS,
            signedCustomerAgreement: constants.SECCL_CUSTODIAN_TERMS,
            ...(props.accountType === 'JISA' && props.jisaChildDetails
                ? {
                    child: {
                        taxDomicile: 'GB',
                        nationality: 'GB',
                        surname: props.jisaChildDetails.surname,
                        address: props.jisaChildDetails.address,
                        firstName: props.jisaChildDetails.firstName,
                        dateOfBirth: props.jisaChildDetails.dateOfBirth,
                        hasPriorJisa: props.jisaChildDetails.hasPriorJisa,
                    },
                }
                : {}),
            ...(props.accountType === 'ISA' && props.accountsHeldElsewhere?.length
                ? { accountsHeldElsewhere: props.accountsHeldElsewhere }
                : {}),
            postOpen: props.postOpenDetails,
        }),
        types: [
            localTypes.CREATE_TRADING_ACCOUNT_REQUEST,
            localTypes.CREATE_TRADING_ACCOUNT_SUCCESS,
            localTypes.CREATE_TRADING_ACCOUNT_FAILURE,
        ],
        extra: {
            accountType: props.accountType,
            broker: props.broker,
            jisaChildDetails: props.jisaChildDetails,
            accountsHeldElsewhere: props.accountsHeldElsewhere?.filter((product) => product === 'CASH' || product === 'STOCKS_AND_SHARES'),
            hasPostOpenInstructions: props.hasPostOpenInstructions,
        },
    },
});
export const getConnectedAccount = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/connected-account',
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            localTypes.GET_CONNECTED_ACCOUNT_REQUEST,
            localTypes.GET_CONNECTED_ACCOUNT_SUCCESS,
            localTypes.GET_CONNECTED_ACCOUNT_FAILURE,
        ],
    },
});
export const setConnectedAccount = (accountId) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/connected-account',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ accountId }),
        types: ['SET_CONNECTED_ACCOUNT_REQUEST', 'SET_CONNECTED_ACCOUNT_SUCCESS', 'SET_CONNECTED_ACCOUNT_ERROR'],
        muteAlert: true,
    },
});
export const getStockMeta = (assetId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/company-information?assetIds=${assetId}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [localTypes.GET_STOCK_META_REQUEST, localTypes.GET_STOCK_META_SUCCESS, localTypes.GET_STOCK_META_FAILURE],
    },
});
export const getDirectDebitEstimatedDate = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/direct-debit/estimated-collection-date',
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            localTypes.GET_DIRECT_DEBIT_ESTIMATED_DATE_REQUEST,
            localTypes.GET_DIRECT_DEBIT_ESTIMATED_DATE_SUCCESS,
            localTypes.GET_DIRECT_DEBIT_ESTIMATED_DATE_FAILURE,
        ],
    },
});
export const getAssetInfo = (assetIds) => {
    let queryString = assetIds.length ? `?assetIds[]=${assetIds[0]}` : '';
    for (let i = 1; i < assetIds.length; i++) {
        queryString += `&assetIds[]=${assetIds[i]}`;
    }
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/assets-info${queryString}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            types: ['GET_ASSET_INFO_REQUEST', 'GET_ASSET_INFO_SUCCESS', 'GET_ASSET_INFO_FAILURE'],
        },
    };
};
// TODO(Lyf) api
/*
 *   types: undefined | ['buy', 'sell'] | ['dividend'] | ['withdraw', 'deposit', 'isa_transfer_in'] | ['interest'],
 */
export const getActivities = (params) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/activity?${queryString.stringify(prepareParams({ ...params }))}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [localTypes.GET_ACTIVITIES_REQUEST, localTypes.GET_ACTIVITIES_SUCCESS, localTypes.GET_ACTIVITIES_FAILURE],
        extra: {
            types: params.types,
            paging: params.paging,
            assetIds: params.assetIds,
            accountId: params.accountId,
        },
    },
});
export const getRecurringBuys = (assetId) => {
    const queryParams = {
        page: 1,
        perPage: 10000,
    };
    if (assetId) {
        queryParams.assetId = assetId;
    }
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/recurring?${queryString.stringify(queryParams)}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: ['GET_RECURRING_BUYS_REQUEST', 'GET_RECURRING_BUYS_SUCCESS', 'GET_RECURRING_BUYS_FAILURE'],
            extra: assetId,
        },
    };
};
export const deleteRecurringBuy = (id, assetId, pin) => ({
    [CALL_API]: {
        method: 'DELETE',
        endpoint: `/wealth/trading/recurring/${id}`,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: ['DELETE_RECURRING_BUY_REQUEST', 'DELETE_RECURRING_BUY_SUCCESS', 'DELETE_RECURRING_BUY_FAILURE'],
        extra: { id, assetId },
        scope: 'order:write',
        muteAlert: true,
        pin,
    },
});
export const updateRecurringBuy = (id, params) => {
    const body = 'amount' in params
        ? params
        : {
            nonTradingDayPreference: params.nonTradingDayPreference,
            ...(params.buyConfig.interval === invest.RecurringBuyInterval.WEEKLY
                ? {
                    dayOfWeek: params.buyConfig.day,
                    period: invest.RecurringBuyInterval.WEEKLY,
                }
                : {
                    period: params.buyConfig.interval,
                    dayOfMonth: params.buyConfig.date,
                }),
        };
    return {
        [CALL_API]: {
            method: 'PATCH',
            endpoint: `/wealth/trading/recurring/${id}`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: ['UPDATE_RECURRING_BUY_REQUEST', 'UPDATE_RECURRING_BUY_SUCCESS', 'UPDATE_RECURRING_BUY_FAILURE'],
            body: JSON.stringify(body),
        },
    };
};
export const getOrders = (params) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/orders?${queryString.stringify(prepareParams(params))}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [localTypes.GET_ORDERS_REQUEST, localTypes.GET_ORDERS_SUCCESS, localTypes.GET_ORDERS_FAILURE],
        extra: params,
    },
});
export const getOrder = (id, accountId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/orders/${id}?${queryString.stringify(prepareParams({
            accountId,
        }))}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [localTypes.GET_ORDER_REQUEST, localTypes.GET_ORDER_SUCCESS, localTypes.GET_ORDER_FAILURE],
        extra: { accountId },
    },
});
export const getPositions = (params) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/positions?${queryString.stringify(prepareParams(params))}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [localTypes.GET_POSITIONS_REQUEST, localTypes.GET_POSITIONS_SUCCESS, localTypes.GET_POSITIONS_FAILURE],
        extra: {
            assetIds: params.assetIds,
            accountId: params.accountId,
        },
    },
});
export const getOrderPreview = (amountOrQuantity, assetId, tradingAccountId, operation, limitStopOrderInfo, fundOrderWithDirectDebit, fundOrderWithOpenBanking) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/orders/preview',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(operation === 'buy'
            ? {
                accountId: tradingAccountId,
                assetId,
                operation,
                ...(limitStopOrderInfo?.orderType === invest.OrderType.LIMIT
                    ? {
                        ...limitStopOrderInfo,
                        quantity: amountOrQuantity,
                    }
                    : {
                        amount: amountOrQuantity,
                    }),
                ...(fundOrderWithDirectDebit && {
                    fundOrderWithDirectDebit: true,
                }),
                ...(fundOrderWithOpenBanking && {
                    fundOrderWithOpenBanking: true,
                }),
            }
            : {
                assetId,
                operation,
                accountId: tradingAccountId,
                quantity: amountOrQuantity,
                ...(limitStopOrderInfo || {}),
            }),
        types: ['GET_ORDER_PREVIEW_REQUEST', 'GET_ORDER_PREVIEW_SUCCESS', 'GET_ORDER_PREVIEW_ERROR'],
        muteAlert: true,
    },
});
export const cacheOrder = (createOrderRawResponse, accountId) => ({
    type: localTypes.CREATE_ORDER_SUCCESS,
    payload: createOrderRawResponse,
    apiPayload: { url: '/wealth/trading/orders' },
    extra: { accountId },
});
export const cancelOrder = (orderId, pin, accountId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/orders/${orderId}/cancel`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: ['CANCEL_ORDER_REQUEST', localTypes.CANCEL_ORDER_SUCCESS, 'CANCEL_ORDER_ERROR'],
        muteAlert: true,
        pin,
        scope: 'order:write',
        extra: { orderId, accountId },
    },
});
export const getHistoricalPrices = (params) => {
    const adjustedParams = { ...params, asBars: true };
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/historical-prices?${queryString.stringify(adjustedParams)}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            types: ['GET_HISTORICAL_PRICES_REQUEST', 'GET_HISTORICAL_PRICES_SUCCESS', 'GET_HISTORICAL_PRICES_ERROR'],
        },
    };
};
export const getPortfolioChart = (params) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/portfolio/chart?${queryString.stringify(params)}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: ['GET_PORTFOLIO_CHART_REQUEST', 'GET_PORTFOLIO_CHART_SUCCESS', 'GET_PORTFOLIO_CHART_ERROR'],
    },
});
export const getSectors = () => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: '/wealth/trading/assets-categories',
        types: ['GET_SECTORS_REQUEST', 'GET_SECTORS_SUCCESS', 'GET_SECTORS_ERROR'],
    },
});
export const getTransferDetails = () => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: '/wealth/ledger',
        types: ['GET_TRANSFER_DETAILS_REQUEST', 'GET_TRANSFER_DETAILS_SUCCESS', 'GET_TRANSFER_DETAILS_FAILURE'],
    },
});
export const getTransferProviders = (accountType, type) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/transfer-providers?wrapperType=${accountType}&previousProviderAccountType=${type}&page=1&perPage=500`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            localTypes.GET_TRANSFER_PROVIDERS_REQUEST,
            localTypes.GET_TRANSFER_PROVIDERS_SUCCESS,
            localTypes.GET_TRANSFER_PROVIDERS_FAILURE,
        ],
        extra: { accountType, type },
    },
});
export const createProductTransfer = (params) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/transfers',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(params),
        types: [
            localTypes.CREATE_PRODUCT_TRANSFER_REQUEST,
            localTypes.CREATE_PRODUCT_TRANSFER_SUCCESS,
            localTypes.CREATE_PRODUCT_TRANSFER_FAILURE,
        ],
        extra: { accountId: params.accountId },
    },
});
export const getProductTransfer = (productTransferId, tradingAccountId) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/transfers/${productTransferId}`,
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: [
            localTypes.GET_PRODUCT_TRANSFER_REQUEST,
            localTypes.GET_PRODUCT_TRANSFER_SUCCESS,
            localTypes.GET_PRODUCT_TRANSFER_FAILURE,
        ],
        extra: {
            tradingAccountId,
        },
    },
});
export const getStaticCollectionsStocks = (type, limit = 20) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/trading/assets/list?type=${type}&limit=${limit}`,
        types: [
            'GET_STATIC_COLLECTION_STOCKS_REQUEST',
            'GET_STATIC_COLLECTION_STOCKS_SUCCESS',
            'GET_STATIC_COLLECTION_STOCKS_FAILURE',
        ],
        extra: { type },
    },
});
/**
 * `GET /wealth/trading/trending-stocks?interval=RANGE_1W&limit=8`
 *
 * @deprecated Only for deprecated broker Alpaca
 * @param limit How many stocks do you want?
 * @returns An API call to be dispatched
 */
export const getTopTrendingStocks = (limit, broker, accountId) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/trading/trending-stocks?interval=RANGE_1W&limit=${limit}&broker=${broker}`,
        types: ['GET_TOP_TRENDING_STOCKS_REQUEST', 'GET_TOP_TRENDING_STOCKS_SUCCESS', 'GET_TOP_TRENDING_STOCKS_ERROR'],
        extra: { accountId },
    },
});
export const getMostWatchedStocks = (limit) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/trading/assets/list?type=MOST_WATCHED&limit=${limit}`,
        types: ['GET_MOST_WATCHED_STOCKS_REQUEST', 'GET_MOST_WATCHED_STOCKS_SUCCESS', 'GET_MOST_WATCHED_STOCKS_ERROR'],
    },
});
export const getMostHeldStocks = (limit) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/trading/assets/list?type=MOST_POPULAR&limit=${limit}`,
        types: ['GET_MOST_HELD_STOCKS_REQUEST', 'GET_MOST_HELD_STOCKS_SUCCESS', 'GET_MOST_HELD_STOCKS_ERROR'],
    },
});
export const getRecurringBuyPreview = ({ amount, assetId, buyConfig, nonTradingDayPreference, }) => {
    const body = 'day' in buyConfig
        ? {
            assetId,
            amount,
            nonTradingDayPreference,
            dayOfWeek: buyConfig.day,
            period: buyConfig.interval,
        }
        : {
            amount,
            assetId,
            nonTradingDayPreference,
            dayOfMonth: buyConfig.date,
            period: buyConfig.interval,
        };
    return {
        [CALL_API]: {
            method: 'POST',
            muteAlert: true,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            endpoint: '/wealth/trading/recurring/preview',
            types: [
                'GET_RECURRING_BUY_PREVIEW_REQUEST',
                'GET_RECURRING_BUY_PREVIEW_SUCCESS',
                'GET_RECURRING_BUY_PREVIEW_ERROR',
            ],
        },
    };
};
export const createRecurringBuy = ({ pin, amount, assetId, buyConfig, nonTradingDayPreference, }) => {
    const body = 'day' in buyConfig
        ? {
            assetId,
            amount,
            nonTradingDayPreference,
            dayOfWeek: buyConfig.day,
            period: buyConfig.interval,
        }
        : {
            amount,
            assetId,
            nonTradingDayPreference,
            dayOfMonth: buyConfig.date,
            period: buyConfig.interval,
        };
    return {
        [CALL_API]: {
            pin,
            method: 'POST',
            muteAlert: true,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
            endpoint: '/wealth/trading/recurring',
            types: ['CREATE_RECURRING_BUY_REQUEST', 'CREATE_RECURRING_BUY_SUCCESS', 'CREATE_RECURRING_BUY_ERROR'],
            scope: 'order:write',
        },
    };
};
export const withdraw = (amount, pin) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/withdraw-cash',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amount }),
        types: ['WITHDRAW_REQUEST', 'WITHDRAW_SUCCESS', 'WITHDRAW_ERROR'],
        muteAlert: true,
        pin,
        scope: 'wallet:withdraw',
        reuseXRequestIdOnRetry: true,
    },
});
export const getSearchResults = (broker, searchTerm, currentPage, typeQueryParams, withPrices) => {
    const queryParams = {
        fractionable: true,
        page: currentPage ?? 1,
        perPage: broker === 'seccl' ? 1000 : 40,
        sorting: 'name',
        broker,
        accountType: 'GIA',
    };
    if (searchTerm) {
        queryParams.search = searchTerm;
    }
    if (typeof withPrices === 'boolean') {
        queryParams.withPrices = withPrices;
    }
    let endpoint = `/wealth/trading/assets?${queryString.stringify(queryParams)}`;
    if (typeQueryParams) {
        Object.keys(typeQueryParams).forEach((queryParamKey) => {
            endpoint += `&${queryParamKey}=${typeQueryParams[queryParamKey]}`;
        });
    }
    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: ['GET_SEARCH_RESULTS_REQUEST', localTypes.GET_SEARCH_RESULTS_SUCCESS, 'GET_SEARCH_RESULTS_ERROR'],
            extra: { broker, currentPage, searchTerm, withPrices },
        },
    };
};
const getStortingType = (filterCategory) => {
    switch (filterCategory) {
        case invest.AssetFilterCategory.SYMBOL:
            return 'symbol';
        case invest.AssetFilterCategory.PRICE:
            return '-sharePrice';
        case invest.AssetFilterCategory.PRICE_CHANGE:
            return '-sharePriceChange';
        default:
            return 'name';
    }
};
export const getStockGroup = (id, type, currentPage, filterCategory) => {
    const queryParams = {
        page: currentPage ?? 1,
        perPage: 40,
        sorting: getStortingType(filterCategory),
    };
    const endpoint = `/wealth/trading/assets/${type === Categories.SECTORS ? 'category' : 'collection'}/${id}?${queryString.stringify(queryParams)}`;
    return {
        [CALL_API]: {
            endpoint,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: ['GET_STOCK_GROUP_REQUEST', 'GET_STOCK_GROUP_SUCCESS', 'GET_STOCK_GROUP_FAILURE'],
        },
    };
};
export const getDocumentUploadUrl = (type, numberOfDocuments, addressId, isChangeOfAddress) => ({
    [CALL_API]: {
        endpoint: '/wealth/kyc/document-check',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ type, numberOfDocuments, addressId, isChangeOfAddress }),
        types: ['DOCUMENT_CHECK_REQUEST', 'DOCUMENT_CHECK_SUCCESS', 'DOCUMENT_CHECK_ERROR'],
        muteAlert: true,
    },
});
export const getScannedSignatureUploadUrl = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/transfer-preupload-signatures',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'GET_SCANNED_SIGNATURE_UPLOAD_URL_REQUEST',
            'GET_SCANNED_SIGNATURE_UPLOAD_URL_SUCCESS',
            'GET_SCANNED_SIGNATURE_UPLOAD_URL_ERROR',
        ],
        muteAlert: true,
    },
});
export const editJISAChildAddressAction = (accountId, address) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/accounts/${accountId}/child/address`,
        method: 'PATCH',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ address }),
        types: [
            localTypes.EDIT_JISA_CHILD_ADDRESS_REQUEST,
            localTypes.EDIT_JISA_CHILD_ADDRESS_SUCCESS,
            localTypes.EDIT_JISA_CHILD_ADDRESS_FAILURE,
        ],
        extra: { accountId, address },
    },
});
export const transferProductLater = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/accounts/accounts-held-elsewhere/dismiss',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            localTypes.TRANSFER_PRODUCT_LATER_REQUEST,
            localTypes.TRANSFER_PRODUCT_LATER_SUCCESS,
            localTypes.TRANSFER_PRODUCT_LATER_FAILURE,
        ],
    },
});
/**
 * GET `/wealth/trading/assets-prices`
 */
export const getLatestPrices = (assetIds) => {
    let queryString = assetIds.length ? `?assetIds[]=${assetIds[0]}` : '';
    for (let i = 1; i < assetIds.length; i++) {
        queryString += `&assetIds[]=${assetIds[i]}`;
    }
    return {
        [CALL_API]: {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            endpoint: `/wealth/trading/assets-prices${queryString}`,
            types: ['GET_LATEST_PRICE_INFO_REQUEST', 'GET_LATEST_PRICE_INFO_SUCCESS', 'GET_LATEST_PRICE_INFO_ERROR'],
        },
    };
};
export const getStocksMeta = (symbols) => {
    let queryString = symbols.length ? `?symbols[]=${symbols[0]}` : '';
    for (let i = 1; i < symbols.length; i++) {
        queryString += `&symbols[]=${symbols[i]}`;
    }
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/company-information${queryString}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            types: ['GET_STOCKS_META_REQUEST', 'GET_STOCKS_META_SUCCESS', 'GET_STOCKS_META_FAILURE'],
        },
    };
};
export const cacheTradingAccount = (account) => ({
    type: 'CACHE_TRADING_ACCOUNT',
    payload: {
        account,
    },
});
export const cacheConnectedAccount = (account) => ({
    type: 'GET_CONNECTED_ACCOUNT_SUCCESS',
    payload: {
        account,
    },
});
export const cacheAccounts = (tradingAccount, connectedAccount) => ({
    type: 'CACHE_ACCOUNTS',
    tradingAccount,
    connectedAccount,
});
/**
 * Create a new watchlist.
 * `POST /wealth/trading/watchlists`
 * @returns The newly created watchlist, without assets
 */
export function createWatchlist(name, emoji) {
    return {
        [CALL_API]: {
            endpoint: '/wealth/trading/watchlists',
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name, emoji }),
            types: ['CREATE_WATCHLIST_REQUEST', 'CREATE_WATCHLIST_SUCCESS', 'CREATE_WATCHLIST_ERROR'],
        },
    };
}
/**
 * `GET /wealth/trading/watchlists`
 * @returns All user watchlists without assets
 */
export function getWatchlists() {
    return {
        [CALL_API]: {
            endpoint: '/wealth/trading/watchlists',
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            types: ['GET_WATCHLISTS_REQUEST', 'GET_WATCHLISTS_SUCCESS', 'GET_WATCHLISTS_ERROR'],
        },
    };
}
export function updateWatchlist(watchlistId, params) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/watchlists/${watchlistId}`,
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(params),
            types: ['UPDATE_WATCHLIST_REQUEST', 'UPDATE_WATCHLIST_SUCCESS', 'UPDATE_WATCHLIST_FAILURE'],
        },
    };
}
/**
 * Delete a watchlist.
 * `DELETE /wealth/trading/watchlists/{watchlistId}`
 * @param watchlistId The ID of the watchlist to delete. You can even delete it multiple times - no error will be raised on backend.
 * @returns nothing
 */
export function deleteWatchlist(watchlistId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/watchlists/${watchlistId}`,
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
            },
            types: ['DELETE_WATCHLIST_REQUEST', 'DELETE_WATCHLIST_SUCCESS', 'DELETE_WATCHLIST_ERROR'],
            extra: { watchlistId },
        },
    };
}
/**
 * Returns the specified watchlist with assets and prices.
 * `GET /wealth/trading/watchlists/{watchlistId}`
 * @param watchlistId The ID of the watchlist.
 * @returns The specified watchlist with assets and prices.
 */
export function getWatchlist(watchlistId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/watchlists/${watchlistId}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            types: ['GET_WATCHLIST_REQUEST', 'GET_WATCHLIST_SUCCESS', 'GET_WATCHLIST_ERROR'],
        },
    };
}
export function addAssetToWatchlist(watchlistId, symbol, assetId, name) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/watchlists/${watchlistId}/assets/assetId/${assetId}`,
            method: 'PUT',
            headers: {
                Accept: 'application/json',
            },
            types: ['ADD_ASSET_TO_WATCHLIST_REQUEST', 'ADD_ASSET_TO_WATCHLIST_SUCCESS', 'ADD_ASSET_TO_WATCHLIST_ERROR'],
            extra: { symbol, watchlistId, assetId, name },
        },
    };
}
export function getWatchListsOfStock(assetId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/asset-watchlists?assetId=${assetId}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            types: ['GET_WATCHLIST_OF_STOCK_REQUEST', 'GET_WATCHLIST_OF_STOCK_SUCCESS', 'GET_WATCHLIST_OF_STOCK_ERROR'],
            extra: { assetId },
        },
    };
}
export function removeAssetFromWatchlist(watchlistId, symbol, assetId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/watchlists/${watchlistId}/assets/assetId/${assetId}`,
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
            },
            types: [
                'REMOVE_ASSET_FROM_WATCHLIST_REQUEST',
                'REMOVE_ASSET_FROM_WATCHLIST_SUCCESS',
                'REMOVE_ASSET_FROM_WATCHLIST_ERROR',
            ],
            extra: { symbol, watchlistId, assetId },
        },
    };
}
export const getFreeSharesClaimable = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/portfolio/free-shares',
        method: 'GET',
        headers: { Accept: 'application/json' },
        types: ['GET_FREE_SHARES_REQUEST', 'GET_FREE_SHARES_SUCCESS', 'GET_FREE_SHARES_ERROR'],
    },
});
export const claimFreeShare = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/portfolio/claim-free-share',
        method: 'GET',
        headers: { Accept: 'application/json' },
        types: ['CLAIM_FREE_SHARE_REQUEST', 'CLAIM_FREE_SHARE_SUCCESS', 'CLAIM_FREE_SHARE_ERROR'],
    },
});
export const getStockNews = (assetId, limit) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/news/v2/${assetId}${limit ? `?limit=${limit}` : ''}`,
        method: 'GET',
        headers: { Accept: 'application/json' },
        types: ['GET_STOCK_NEWS_REQUEST', 'GET_STOCK_NEWS_SUCCESS', 'GET_STOCK_NEWS_ERROR'],
        extra: { assetId, limit },
    },
});
export const getStockFinancials = (assetId, period) => {
    let periodQueryParam = 'annual';
    switch (true) {
        case period === invest.FinancialsPeriod.QUARTERLY:
            periodQueryParam = 'quarter';
            break;
        default:
            break;
    }
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/assets/${assetId}/financials?period=${periodQueryParam}&limit=4`,
            method: 'GET',
            headers: { Accept: 'application/json' },
            types: ['GET_STOCK_FINANCIALS_REQUEST', 'GET_STOCK_FINANCIALS_SUCCESS', 'GET_STOCK_FINANCIALS_FAILURE'],
            extra: { assetId, period },
        },
    };
};
export function getRecurringBuyActivities(id, paging) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/recurring/${id}/activity?${queryString.stringify(prepareParams({ paging }))}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            extra: { id },
            types: [
                'GET_RECURRING_BUY_ACTIVITIES_REQUEST',
                'GET_RECURRING_BUY_ACTIVITIES_SUCCESS',
                'GET_RECURRING_BUY_ACTIVITIES_FAILURE',
            ],
        },
    };
}
export function getFxFees() {
    return {
        [CALL_API]: {
            endpoint: '/wealth/trading/foreign-exchange/fees',
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: ['GET_FX_FEES_REQUEST', 'GET_FX_FEES_SUCCESS', 'GET_FX_FEES_FAILURE'],
        },
    };
}
export function getFundAllocations(assetId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/assets/${assetId}/fund-breakdown`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: ['GET_FUND_ALLOCATIONS_REQUEST', 'GET_FUND_ALLOCATIONS_SUCCESS', 'GET_FUND_ALLOCATIONS_FAILURE'],
            extra: assetId,
        },
    };
}
export function getSecclAUMFees() {
    return {
        [CALL_API]: {
            endpoint: '/wealth/trading/aum-fees',
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: ['GET_SECCL_AUM_FEES_REQUEST', 'GET_SECCL_AUM_FEES_SUCCESS', 'GET_SECCL_AUM_FEES_FAILURE'],
        },
    };
}
export const getCostsAndCharges = (dateFrom, dateTo) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/trading/statements/costs-and-charges?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        types: ['GET_COSTS_AND_CHARGES_REQUEST', 'GET_COSTS_AND_CHARGES_SUCCESS', 'GET_COSTS_AND_CHARGES_ERROR'],
        muteAlert: false,
    },
});
export const getValuationStatement = (accountId) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/trading/statements?${queryString.stringify(prepareParams({ accountId, paging: { page: 1, perPage: 100 } }))}`,
        types: ['GET_VALUATION_STATEMENT_REQUEST', 'GET_VALUATION_STATEMENT_SUCCESS', 'GET_VALUATION_STATEMENT_ERROR'],
    },
});
export const getCapitalGainsAndIncome = (dateFrom, dateTo) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/trading/statements/activity?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        types: [
            'GET_CAPITAL_GAINS_AND_CHARGES_REQUEST',
            'GET_CAPITAL_GAINS_AND_CHARGES_SUCCESS',
            'GET_CAPITAL_GAINS_AND_CHARGES_ERROR',
        ],
        muteAlert: false,
    },
});
export const getPotsStatement = (dateFrom, dateTo) => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: `/wealth/pots/statement?dateFrom=${dateFrom}&dateTo=${dateTo}`,
        types: ['GET_POTS_STATEMENT_REQUEST', 'GET_POTS_STATEMENT_SUCCESS', 'GET_POTS_STATEMENT_ERROR'],
        muteAlert: false,
    },
});
export const getRequiredNationalIdentifiers = () => ({
    [CALL_API]: {
        endpoint: '/me/national-identifiers/required',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'GET_REQUIRED_NATIONAL_IDENTIFIERS_REQUEST',
            'GET_REQUIRED_NATIONAL_IDENTIFIERS_SUCCESS',
            'GET_REQUIRED_NATIONAL_IDENTIFIERS_FAILURE',
        ],
    },
});
export const getPatternDayTradingInfo = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/pattern-day-trading',
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        types: [
            'GET_PATTERN_DAY_TRADING_INFO_REQUEST',
            'GET_PATTERN_DAY_TRADING_INFO_SUCCESS',
            'GET_PATTERN_DAY_TRADING_INFO_FAILURE',
        ],
    },
});
export const postRequiredNationalIdentifiers = (type, country, value) => ({
    [CALL_API]: {
        endpoint: '/me/national-identifiers',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            type,
            value,
            country,
        }),
        extra: {
            type,
            value,
            country,
        },
        types: [
            'POST_REQUIRED_NATIONAL_IDENTIFIERS_REQUEST',
            'POST_REQUIRED_NATIONAL_IDENTIFIERS_SUCCESS',
            'POST_REQUIRED_NATIONAL_IDENTIFIERS_FAILURE',
        ],
    },
});
export function getAnalystInfo(assetId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/assets-analysts-info?assetId=${assetId}`,
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
            types: [
                'INVEST_GET_ANALYST_INFO_REQUEST_ACTION',
                'INVEST_GET_ANALYST_INFO_SUCCESS_ACTION',
                'INVEST_GET_ANALYST_INFO_FAILURE_ACTION',
            ],
            extra: { assetId },
        },
    };
}
export const clearTradingBlockExpiryDateAction = () => ({
    type: 'CLEAR_TRADING_BLOCK_EXPIRY_DATE_ACTION',
});
/**
 * blockUntilDate must be in UTC
 */
export function addBuyBlock(blockUntilDate) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/account/trading-block`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                blockUntilDate,
            }),
            types: [
                'INVEST_ADD_BUY_BLOCK_REQUEST_ACTION',
                'INVEST_ADD_BUY_BLOCK_SUCCESS_ACTION',
                'INVEST_ADD_BUY_BLOCK_FAILURE_ACTION',
            ],
            extra: { blockUntilDate },
        },
    };
}
export function closeUserTradingAccount(accountId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/accounts/${accountId}`,
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: [
                'CLOSE_USER_TRADING_ACCOUNT_REQUEST_ACTION',
                'CLOSE_USER_TRADING_ACCOUNT_SUCCESS_ACTION',
                'CLOSE_USER_TRADING_ACCOUNT_FAILURE_ACTION',
            ],
            extra: { accountId },
        },
    };
}
export function getAnalystRatingsDetails(assetId) {
    return {
        [CALL_API]: {
            method: 'GET',
            endpoint: `/wealth/trading/assets-analysts-info/${assetId}/history`,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            types: [
                'GET_ANALYST_RATINGS_DETAILS_REQUEST_ACTION',
                'GET_ANALYST_RATINGS_DETAILS_SUCCESS_ACTION',
                'GET_ANALYST_RATINGS_DETAILS_FAILURE_ACTION',
            ],
        },
    };
}
export const clearOnboardingState = () => ({
    type: 'CLEAR_ONBOARDING_STATE',
});
// Keeps the onboarding in progress for its account type, so the user can continue it later.
export const pauseOnboardingState = () => ({
    type: 'PAUSE_ONBOARDING_STATE',
});
export const resumeOnboardingState = (accountType) => ({
    type: 'RESUME_ONBOARDING_STATE',
    accountType,
});
export const discardPausedOnboardingState = (accountType) => ({
    type: 'DISCARD_PAUSED_ONBOARDING_STATE',
    accountType,
});
export function createStockAlert(assetId, targetPrice, currentPrice) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/stock-alert`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                assetId,
                targetPrice,
                currentPrice,
            }),
            types: [
                'INVEST_CREATE_STOCK_ALERT_REQUEST_ACTION',
                'INVEST_CREATE_STOCK_ALERT_SUCCESS_ACTION',
                'INVEST_CREATE_STOCK_ALERT_FAILURE_ACTION',
            ],
            extra: {
                assetId,
            },
        },
    };
}
export function editStockAlert(id, assetId, targetPrice) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/stock-alert/${id}`,
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                targetPrice,
            }),
            types: [
                'INVEST_EDIT_STOCK_ALERT_REQUEST_ACTION',
                'INVEST_EDIT_STOCK_ALERT_SUCCESS_ACTION',
                'INVEST_EDIT_STOCK_ALERT_FAILURE_ACTION',
            ],
            extra: {
                id,
                assetId,
            },
        },
    };
}
export function getStockAlerts(assetId, paginationToken) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/stock-alert?status=PENDING${assetId ? `&assetId=${assetId}` : ''}${paginationToken ? `&token=${paginationToken}` : ''}`,
            method: 'GET',
            types: [
                'INVEST_GET_STOCK_ALERTS_REQUEST_ACTION',
                'INVEST_GET_STOCK_ALERTS_SUCCESS_ACTION',
                'INVEST_GET_STOCK_ALERTS_FAILURE_ACTION',
            ],
            extra: {
                assetId: assetId || constants.ALL_STOCKS_KEY,
            },
        },
    };
}
export function getTriggeredStockAlerts(assetId, paginationToken) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/trading/stock-alert?status=TRIGGERED${assetId ? `&assetId=${assetId}` : ''}${paginationToken ? `&token=${paginationToken}` : ''}`,
            method: 'GET',
            types: [
                'INVEST_GET_TRIGGERED_STOCK_ALERTS_REQUEST_ACTION',
                'INVEST_GET_TRIGGERED_STOCK_ALERTS_SUCCESS_ACTION',
                'INVEST_GET_TRIGGERED_STOCK_ALERTS_FAILURE_ACTION',
            ],
            extra: {
                paginationToken,
                assetId: assetId || constants.ALL_STOCKS_KEY,
            },
        },
    };
}
export const deleteStockAlert = (alertId, assetId) => ({
    [CALL_API]: {
        method: 'DELETE',
        endpoint: `/wealth/trading/stock-alert/${alertId}`,
        types: [
            'INVEST_DELETE_STOCK_ALERT_REQUEST',
            'INVEST_DELETE_STOCK_ALERT_SUCCESS',
            'INVEST_DELETE_STOCK_ALERT_FAILURE',
        ],
        extra: { alertId, assetId },
    },
});
export const getRealTimePricesSuccess = (payload) => ({
    payload,
    type: localTypes.GET_REAL_TIME_PRICES_SUCCESS,
});
export const setAssetIdToFetchRealTimePrices = (assetId) => ({
    assetId,
    type: localTypes.SET_ASSET_ID_TO_FETCH_REAL_TIME_PRICES,
});
export const removeAssetIdToFetchRealTimePrices = (assetId) => ({
    assetId,
    type: localTypes.REMOVE_ASSET_ID_TO_FETCH_REAL_TIME_PRICES,
});
export const getCorporateEvents = (assetIds, calendarKey, futureToken, types) => ({
    [CALL_API]: {
        method: 'GET',
        endpoint: `/wealth/trading/assets/investment-calendar?${queryString.stringify(prepareParams({
            assetIds,
        }))}${futureToken ? `&futureToken:${futureToken}` : ''}${types
            ? `&${queryString.stringify(prepareParams({
                types,
            }))}`
            : ''}`,
        types: [
            'INVEST_GET_CORPORATE_EVENTS_REQUEST',
            'INVEST_GET_CORPORATE_EVENTS_SUCCESS',
            'INVEST_GET_CORPORATE_EVENTS_FAILURE',
        ],
        extra: {
            types,
            assetIds,
            futureToken,
            calendarKey,
        },
    },
});
export const getCompactTradingActivityForAssetId = (assetId) => ({
    [CALL_API]: {
        method: 'GET',
        endpoint: `/wealth/trading/activity/${assetId}/compact`,
        types: [
            'INVEST_GET_COMPACT_TRADING_ACTIVITY_REQUEST',
            'INVEST_GET_COMPACT_TRADING_ACTIVITY_SUCCESS',
            'INVEST_GET_COMPACT_TRADING_ACTIVITY_FAILURE',
        ],
        extra: {
            assetId,
        },
    },
});
export const getSpaceTradingAccounts = (spaceId) => ({
    [CALL_API]: {
        method: 'GET',
        endpoint: `/wealth/spaces/${spaceId}/trading`,
        types: [
            'GET_SPACE_TRADING_ACCOUNTS_REQUEST',
            'GET_SPACE_TRADING_ACCOUNTS_SUCCESS',
            'GET_SPACE_TRADING_ACCOUNTS_ERROR',
        ],
        extra: {
            spaceId,
        },
        headers: {
            Accept: 'application/json',
        },
    },
});
export function setTradingAccountSpace(spaceId, tradingAccountId) {
    return {
        [CALL_API]: {
            endpoint: `/wealth/spaces/${spaceId}/add-trading-account?accountId=${tradingAccountId}`,
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            types: [
                'SET_TRADING_ACCOUNT_SPACE_REQUEST',
                'SET_TRADING_ACCOUNT_SPACE_SUCCESS',
                'SET_TRADING_ACCOUNT_SPACE_FAILURE',
            ],
            extra: {
                spaceId,
                tradingAccountId,
            },
        },
    };
}
export const getTradingMarketsInfo = () => ({
    [CALL_API]: {
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        endpoint: '/wealth/trading/markets',
        types: ['GET_TRADING_MARKETS_INFO_REQUEST', 'GET_TRADING_MARKETS_INFO_SUCCESS', 'GET_TRADING_MARKETS_INFO_ERROR'],
    },
});
export const getTradingAccounts = () => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/accounts',
        method: 'GET',
        headers: {
            Accept: 'application/json',
        },
        types: ['GET_TRADING_ACCOUNTS_REQUEST', 'GET_TRADING_ACCOUNTS_SUCCESS', 'GET_TRADING_ACCOUNTS_FAILURE'],
    },
});
export const updateWealthAccounts = (props) => ({
    type: localTypes.UPDATE_WEALTH_ACCOUNTS,
    skipGetPositions: props?.skipGetPositions,
    fetchPendingTopups: props?.fetchPendingTopups,
});
export const updateWealthAccountsWithRetry = (retryTimes, broker, accountType) => ({
    broker,
    retryTimes,
    accountType,
    type: 'UPDATE_WEALTH_ACCOUNTS_WITH_RETRY',
});
export const updateWealthAccountsComplete = () => ({
    type: 'UPDATE_WEALTH_ACCOUNTS_COMPLETE',
});
export const setSelectedTradingAccountId = (accountId) => ({
    accountId,
    type: 'SET_SELECTED_TRADING_ACCOUNT_ID',
});
export const setHmrcAppInstalledAction = (isInstalled) => ({
    isInstalled,
    type: 'SET_HMRC_APP_INSTALLED',
});
export const withdrawTradingAccount = (id, amount, pin) => ({
    [CALL_API]: {
        endpoint: `/wealth/trading/accounts/${id}/withdraw`,
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            amount,
            currency: 'GBP',
        }),
        pin,
        muteAlert: true,
        scope: 'order:write',
        types: ['WITHDRAW_TRADING_ACCOUNT_REQUEST', 'WITHDRAW_TRADING_ACCOUNT_SUCCESS', 'WITHDRAW_TRADING_ACCOUNT_FAILURE'],
        reuseXRequestIdOnRetry: true,
    },
});
export const fetchWealthAccounts = (retryTimes, tradingAccountId) => ({
    type: 'FETCH_WEALTH_ACCOUNTS',
    retryTimes,
    tradingAccountId,
});
export const fetchTradingAccountInfoAfterOrder = (retryTimes, tradingAccountId, assetId) => ({
    type: 'FETCH_TRADING_ACCOUNT_INFO_AFTER_ORDER',
    retryTimes,
    assetId,
    tradingAccountId,
});
export const addRecentlyViewedAssetIdForTradingAccount = (assetId, tradingAccountId) => ({
    type: 'ADD_RECENTLY_VIEWED_ASSET_ID_FOR_TRADING_ACCOUNT',
    assetId,
    tradingAccountId,
});
export const getAssetSwitchOrderPreview = (quantity, assetId, toAssetId, tradingAccountId) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/switch/preview',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sellAssetId: assetId,
            buyAssetId: toAssetId,
            sellQuantity: quantity,
            accountId: tradingAccountId,
        }),
        types: [
            'GET_ASSET_SWITCH_ORDER_PREVIEW_REQUEST',
            'GET_ASSET_SWITCH_ORDER_PREVIEW_SUCCESS',
            'GET_ASSET_SWITCH_ORDER_PREVIEW_ERROR',
        ],
        muteAlert: true,
    },
});
export const createAssetSwitchOrder = (pin, quantity, assetId, toAssetId, tradingAccountId) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/switch',
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sellAssetId: assetId,
            buyAssetId: toAssetId,
            sellQuantity: quantity,
            accountId: tradingAccountId,
        }),
        pin,
        types: [
            'CREATE_ASSET_SWITCH_ORDER_REQUEST',
            'CREATE_ASSET_SWITCH_ORDER_SUCCESS',
            'CREATE_ASSET_SWITCH_ORDER_ERROR',
        ],
        muteAlert: true,
        scope: 'order:write',
    },
});
export const buySecclAssetFromAvailable = ({ pin, amount, assetId, accountId, }) => ({
    [CALL_API]: {
        endpoint: '/wealth/trading/orders',
        method: 'POST',
        muteAlert: true,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            amount,
            assetId,
            accountId,
            operation: 'buy',
            type: 'market',
        }),
        types: [
            'BUY_SECCL_ASSET_FROM_AVAILABLE_REQUEST',
            'BUY_SECCL_ASSET_FROM_AVAILABLE_SUCCESS',
            'BUY_SECCL_ASSET_FROM_AVAILABLE_ERROR',
        ],
        pin,
        scope: 'order:write',
        reuseXRequestIdOnRetry: true,
    },
});
